import QuoteDetail from './QuoteDetail';

export default function QuoteDetailPage() {
  return <QuoteDetail />;
}